import axios from "axios";

function getHeaders() {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`, // Assumes token is stored in localStorage
    },
  };
}

export const getInvoiceCountReport = async (groupBy) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/dashboard/api/invoice-report/invoice_count_report/?group_by=${groupBy}`,
      getHeaders()
    );
    return response.data; // Returning the data field from the API response
  } catch (error) {
    throw new Error(
      error.response?.data?.error || "Failed to fetch invoice count report"
    );
  }
};
